export enum EServicePriceType {
  DYNAMIC = 'DYNAMIC',
  FIXED = 'FIXED',
  FREE = 'FREE',
  PRICE_LOGIC = 'PRICE_LOGIC',
}
